/* Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { RoleUpdateInput, useUpdateRoleMutation } from "~/generated/graphql";
import { showError, showSuccess } from "~/services/toast";
import { generateActionSuccessText } from "~/tools";

type Props = {
  onSuccess: () => void;
};

export function useUpdateRole({ onSuccess }: Props) {
  const [updateRoleMutation, { loading }] = useUpdateRoleMutation({
    onError: () => {
      showError();
    },
    onCompleted: () => {
      onSuccess();
      showSuccess(generateActionSuccessText("Role")()("updated")());
    },
  });

  function updateCloudAccount(data: RoleUpdateInput) {
    updateRoleMutation({
      variables: {
        input: data,
      },
    });
  }

  return [updateCloudAccount, loading] as const;
}
